import { render, staticRenderFns } from "./MyRequestsTab.vue?vue&type=template&id=5cfa4694&scoped=true&lang=pug"
import script from "./MyRequestsTab.vue?vue&type=script&lang=js"
export * from "./MyRequestsTab.vue?vue&type=script&lang=js"
import style0 from "./MyRequestsTab.vue?vue&type=style&index=0&id=5cfa4694&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfa4694",
  null
  
)

export default component.exports